/* eslint-disable max-len */
import axios, { AxiosResponse } from "axios";
import {
  IGetLines,
  ILinePayload,
  PhoneService,
  IUpdateLine,
} from "../models/line.model";

export const createLine = async (payload: ILinePayload) => {
  const formData = new FormData();

  formData.append("phone_type", payload.phone_type.toString());
  formData.append("phone_service", payload.phone_service.toString());
  formData.append("company_number", payload.company_number);
  formData.append("address", payload.address);
  formData.append("country_code", payload.country_code);
  formData.append("name", payload.name);
  formData.append("ein", payload.ein);

  if (payload.phone_service === PhoneService.CALLS_SMS) {
    formData.append(
      "customer_proof_type",
      payload.customer_proof_type.toString()
    );
    formData.append("customer_proof_website", payload.customer_proof_website);
    if (payload.file) {
      formData.append("file", payload.file);
    }
  }

  const res = await axios.post("/line", formData);
  return res;
};

export const getLines = async (payload: IGetLines) => {
  const res = await axios.get("/line", {
    params: {
      limit: payload.limit || 999,
      page: payload.page,
      line_number: payload.line_number,
      status: payload.status,
      sort: payload.sort,
    },
  });
  return res;
};

export const updateLine = async ({
  id,
  payload,
}: {
  id: string;
  payload: IUpdateLine;
}) => {
  const res = await axios.patch(`/line/${id}`, payload);
  return res;
};

export const deleteLine = async (id: string) => {
  const res = await axios.delete(`/line/${id}`);
  return res;
};

export const createGoogleAuthInfo = async (auth_code: string) => {
  const res = await axios.post("/google-calendar/user_info", { auth_code });
  return res;
};

export const getGoogleAuthInfo = async () => {
  const res = await axios.get("/google-calendar/user_info");
  return res;
};

export const assignAgentToLine = async (
  id: string,
  agentId: string,
  inbound_type?: number
) => {
  const payload: { agent_id: string | null; inbound_type: number } = {
    agent_id: agentId || null,
    inbound_type: Number(inbound_type) || 1,
  };
  const res = await axios.patch(`/line/attach-inbound-agent/${id}`, payload);
  return res;
};

export const assignWhatsappAgentToLine = async (
  id: string,
  agentId: string
) => {
  const res = await axios.patch(`/line/attach-whatsapp-agent/${id}`, {
    agent_id: agentId,
  });
  return res;
};
